import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    limit, orderBy
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addShopifyBlogs,
    addSingleShopifyBlog,
    updateShopifyBlogs,
    updateSingleShopifyBlog,
    deleteSingleShopifyBlog,
    getSingleShopifyBlog,
    searchShopifyBlogs,
    prepareShopifyBlogsList
}

const collectionName = 'shopify-blogs';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyBlogs = (shopifyBlogs) => {
    return Promise.map(shopifyBlogs, async shopifyBlog => {
        console.log('.');
        await addSingleShopifyBlog(shopifyBlog);
    });
}

const updateShopifyBlogs = (shopifyBlogs) => {
    return Promise.map(shopifyBlogs, async shopifyBlog => {
        console.log('.');
        await updateSingleShopifyBlog(shopifyBlog);
    });
}

const addSingleShopifyBlog = (shopifyBlog) => {
    return addDoc(collectionReference, shopifyBlog);
}

const updateSingleShopifyBlog = (shopifyBlog) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBlog.id);
    return setDoc(documentReference, shopifyBlog, {merge: true});
}

const deleteSingleShopifyBlog = (shopifyBlog) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBlog.id);
    return deleteDoc(documentReference);
}

const getSingleShopifyBlog = (shopifyBlogId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBlogId);
    return getDoc(documentReference);
}

const searchShopifyBlogs = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        limit(10));

    const shopifyBlogResult = await getDocs(searchQuery);
    return prepareShopifyBlogsList(shopifyBlogResult);
}

const prepareShopifyBlogsList = (shopifyBlogResult) => {
    const shopifyBlogsList = [];

    _.forEach(shopifyBlogResult.docs, shopifyBlogDoc => {
        shopifyBlogsList.push({
            ...shopifyBlogDoc.data(),
            id: shopifyBlogDoc.id
        });
    });

    return shopifyBlogsList;
}
